import { render } from "./documentItem.vue?vue&type=template&id=69c4c428"
import script from "./documentItem.vue?vue&type=script&lang=js"
export * from "./documentItem.vue?vue&type=script&lang=js"

import "./documentItem.vue?vue&type=style&index=0&id=69c4c428&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__